import React from "react";
import Watermark from "./Watermark";
import WelcomeIntro from "./WelcomeIntro";
import OurMission from "./OurMission";
import GetStarted from "./GetStarted";
import ContactUs from "./ContactUs";

export default function WelcomePage({ onGetStarted }) {
  return (
    <div className="relative min-h-screen bg-white overflow-x-hidden flex flex-col items-center">
      {/* Logo & Hero Section */}
      <div className="w-full flex flex-col items-center pt-10 pb-4">
        <Watermark />
        <WelcomeIntro />
      </div>

      {/* Main Content Area */}
      <div className="w-full max-w-5xl flex flex-col md:flex-row justify-center items-start gap-10 mt-6 px-4 md:px-0">
        <div className="flex-1 flex flex-col items-center">
          <OurMission />
          <div className="mt-6 w-full flex justify-center">
            <GetStarted onGetStarted={onGetStarted} />
          </div>
        </div>
        <div className="w-full md:w-[340px] mt-8 md:mt-0 flex-shrink-0 flex justify-center">
          <ContactUs />
        </div>
      </div>
    </div>
  );
}
